// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'power';

export const Component = () => (
  <path d='M11.859 10.334V2.479c0-.335.143-.479.479-.479.335 0 .478.144.478.479v7.855c0 .335-.143.479-.479.479-.335 0-.478-.144-.478-.48Zm3.018-6.035h-.097v1.006c1.772.526 3.161 1.533 4.263 3.017 1.102 1.484 1.628 3.113 1.628 4.98 0 2.3-.814 4.263-2.442 5.891-1.628 1.628-3.592 2.442-5.89 2.442-2.3 0-4.263-.814-5.891-2.442-1.628-1.628-2.443-3.592-2.443-5.89 0-1.869.527-3.497 1.629-4.981 1.101-1.437 2.49-2.442 4.214-2.97l.048-1.054c-2.012.527-3.64 1.629-4.933 3.305C3.67 9.28 3 11.195 3 13.303c0 2.538.91 4.74 2.778 6.56 1.82 1.82 4.023 2.73 6.561 2.73 2.538 0 4.741-.91 6.61-2.73 1.819-1.82 2.73-4.022 2.73-6.56 0-2.108-.624-4.023-1.916-5.7-1.293-1.676-2.922-2.778-4.886-3.305V4.3Z' />
);

export const viewBox = '0 0 25 25';
